export const permissionsEnergyStatement = [
  "energy-statement",
  "everything-full",
  "everything-readonly",
];
